<template>
  <div id="terms-of-service" class="">
    <h1 align="center">
      ความยินยอมในการเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคล
    </h1>
    <p>&nbsp;</p>
    <ol>
      <li>
        <strong>ผู้ควบคุมข้อมูลส่วนบุคคล</strong>
        <span>
            บริษัท เอสซี แอสเสท คอร์ปอเรชั่น จำกัด (มหาชน) (SC) สำนักงานเลขที่ 1010
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ถนนวิภาวดีรังสิต แขวงจตุจักร เขตจตุจักร กรุงเทพมหานคร 10900
        </span>
      </li>
      <li>
        <strong>วัตถุประสงค์ของการเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคล</strong>
        <span>
            เจ้าของข้อมูลส่วนบุคคลยินยอมให้ SC และบริษัทในเครือ สามารถเก็บรวบรวม ใช้ หรือ
            เปิดเผยข้อมูลส่วนบุคคลตามสำเนาบัตรประชาชนและทะเบียนบ้านของเจ้าของข้อมูล รวมถึงข้อมูลรายได้สถานที่ติดต่อหมายเลขโทรศัพท์ และ E-mail หรือ Line ID หรือ
            ข้อมูลอื่นใดที่เจ้าของข้อมูลส่วนบุคคลได้มอบและแจ้งไว้ต่อ SC หรือบริษัทในเครือ เพื่อประกอบข้อมูลในการซื้อบ้าน,ที่ดิน,ห้องชุด และผลิตภัณฑ์อื่นใด รวมถึงการใช้บริการต่างๆ  ที่เกี่ยวข้องกับธุรกิจและ
            บริการของ SC หรือบริษัทในเครือ รวมตลอดถึงข้อมูลชีวภาพ ชีวมิติ เช่น ภาพถ่าย ภาพเคลื่อนไหว เสียง ข้อมูลเกี่ยวกับเชื้อชาติ ความเชื่อส่วนบุคคล ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ความพิการ ข้อมูลสหภาพแรงงาน ข้อมูลพันธุกรรม หรือ
            ข้อมูลอื่นใดที่ SC หรือบริษัทในเครือได้รับมาในทุกรูปแบบหรือบันทึกจากการสัมภาษณ์ด้วยวาจา หรือเจ้าของข้อมูลได้ให้ข้อมูลไว้ในแบบสอบถามหรือทางอิเล็คทรอนิกส์ให้สามารถเก็บรวบรวม ใช้หรือ
            เปิดเผยข้อมูลส่วนบุคคลของเจ้าของข้อมูลเพื่อประโยชน์ในการวิเคราะห์ประมวลผลพัฒนาและใช้ในธุรกิจและบริการของ SC หรือบริษัทในเครืออันอาจเป็นประโยชน์ต่อเจ้าของข้อมูลและ
            ผู้บริโภคได้ โดย SC จะไม่นำข้อมูลไปให้ต่อบุคคลอื่น เว้นแต่สถาบันการเงินที่เจ้าของข้อมูลประสงค์จะขอสินเชื่อหรือสถาบันการเงินอื่นใด เพื่อประโยชน์ต่อการขอสินเชื่อของเจ้าของข้อมูล และ
            บริษัทคู่ค้าของ SC ที่ร่วมประกอบธุรกิจในการก่อสร้างตกแต่งหรือให้บริการใดๆ ร่วมในธุรกิจของ SC และบริษัทในเครือโดยยินยอมให้สถาบันการเงินหรือบริษัทคู่ค้าของ SC สามารถติดต่อเจ้าของข้อมูลเพื่อการใดๆ ได้ตามวัตถุประสงค์ของสถาบันการเงินและ
            บริษัทคู่ค้าของ SC รวมถึงการเสนอการให้บริการและผลิตภัณฑ์ต่างๆของสถาบันการเงินและบริษัทคู่ค้าของ SC รวมถึงการวิเคราะห์ วิจัยจัดทำข้อมูลทางสถิติเพื่อการปรับปรุงการพัฒนาผลิตภัณฑ์การบริการให้ดียิ่งขึ้น ทั้งนี้รวมถึงการส่งหรือโอนข้อมูลส่วนบุคคลไปยังประเทศปลายทาง
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เพื่อวัตถุประสงค์ที่กล่าวข้างต้นทั้งหมด หรือเป็นการเปิดเผย ตามอำนาจหมายศาล หรือที่กฎหมายกำหนดให้เปิดเผย
        </span>
      </li>
      <li>
        <strong>ระยะเวลาในการเก็บรวบรวมข้อมูลส่วนบุคคล</strong>
        <span>
            SC และบริษัทในเครือจะจัดเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคลตลอดระยะเวลาที่เจ้าของข้อมูลยัง
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;คงเป็นสมาชิกผู้ซื้อบ้าน, ที่ดิน, ห้องชุด หรือ
            ผลิตภัณฑ์อื่นใด หรือใช้บริการในธุรกิจของ SC หรือบริษัทในเครืออยู่หรือในกรณีอื่นๆจนกว่าเจ้าของข้อมูลจะถอนความยินยอม
        </span>
      </li>
      <li>
        <strong>การแจ้งเปลี่ยนแปลงข้อมูลหรือถอนความยินยอม</strong>
        <span>
            เจ้าของข้อมูลส่วนบุคคลสามารถแจ้งเปลี่ยนแปลงข้อมูลส่วนบุคคลให้ถูกต้อง หรือจะถอนความยินยอมเมื่อใดก็ได้โดยแจ้งเป็นลายลักษณ์อักษร
            ให้บริษัทรับทราบเป็นหนังสือหรือ E-mail: dataprivacy@scasset.com หรือโทรศัพท์แจ้งที่           Call Center เบอร์โทร. 1749
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;โดยการถอนความยินยอมเจ้าของข้อมูล จะมีผลกระทบต่อการใช้บริการของ SC และ
            บริษัทในเครือที่เกี่ยวข้องใน     ทุกด้านที่เจ้าของข้อมูลส่วนบุคคลใช้บริการอยู่ รวมถึงเจ้าของข้อมูลจะไม่ได้รับข้อมูลข่าวสาร
            อันเป็นสิทธิและประโยชน์ส่วนบุคคลของ SC และบริษัทในเครือ รวมถึงบริษัทคู่ค้าของ SC
        </span>
      </li>
      <li>
        <strong>ติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล</strong>
        <span>
            สำนักตรวจสอบภายใน  สำนักงานเลขที่ 1010 ชั้น P13 ถนนวิภาวดีรังสิต แขวงจตุจักร เขตจตุจักร
            &nbsp;กรุงเทพมหานคร 10900 Email: dataprivacy@scasset.com
        </span>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
#terms-of-service {
  padding: 5%;
  height: 100%;
  overflow-y: scroll;

  h3,
  h4,
  h5,
  h6 {
    text-align: left;
  }

  p {
    margin-top: 10px;
  }

  ul,
  ol {
    color: #000;
    margin-top: 8px;
  }

  li {
    text-align: left;
    font-weight: 400;

    span {
      font-weight: 400;
    }

    p {
      line-height: 1.6rem;
      color: inherit;
    }
  }
}

@media screen and (max-width: 420px) {
  h1 {
    font-size: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/policy/Consent.vue